import { Box, Heading } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

import { ProjectPageTemplate } from '~/components/layout/page-utilities/ProjectPageTemplate';
import { getProjectRoute } from '~/pages/project/projectRoutes';

const ProjectReviewPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <ProjectPageTemplate
      title="Project Review"
      onBack={() => {
        if (id) {
          navigate(getProjectRoute(id, 'PROPOSAL'));
        }
      }}
      backLabel="Back to Proposal"
      onContinue={() => {
        navigate('/');
      }}
    >
      <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
        <Heading size="md">Project Review Page</Heading>
        <Box mt={4}>Project ID: {id}</Box>
      </Box>
    </ProjectPageTemplate>
  );
};

export default ProjectReviewPage;
